var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-title" }, [
    _c("div", { staticClass: "title-en relative" }, [
      _c("div", { staticClass: "title absolute" }, [_vm._v(_vm._s(_vm.title))]),
      _c("div", [_vm._v(_vm._s(_vm.letter))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }